import React from "react";
import { Box } from "theme-ui";

interface TRProps {
  children: React.ReactNode;
}

function TR(props: TRProps) {
  return (
    <Box
      as="tr"
      {...props}
      sx={{
        fontSize: "14px",
      }}
    />
  );
}

export default TR;
